<template>
  <b-modal
    ref="filesModal"
    title="Today's Dispatch Files"
    hide-footer
    @shown="fetchFilesList"
  >
    <div v-if="filesList" id="files-list">
      <div v-if="filesList.certificateFiles.length > 0">
        <h4>Certificates</h4>
        <ul>
          <li
            :key="index"
            v-for="(file, index) in filesList.certificateFiles"
            @click="downloadFile(file, 'certificate')"
          >
            {{ file }}
          </li>
        </ul>
      </div>
      <div v-else>No certificate files generated today.</div>
      <div v-if="filesList.postFiles.length > 0">
        <h4>Post Files</h4>
        <ul>
          <li
            :key="index"
            v-for="(file, index) in filesList.postFiles"
            @click="downloadFile(file, 'post')"
          >
            {{ file }}
          </li>
        </ul>
      </div>
      <div v-else>No post files generated today.</div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "files-modal",
  data() {
    return {
      filesList: null
    };
  },
  methods: {
    downloadFile(file, type) {
      window.location =
        this.APIURL + this.BRAND + "/dispatch-download/" + file + "/" + type;
    },
    fetchFilesList() {
      let loader = this.$loading.show();
      this.$http
        .get(this.APIURL + this.BRAND + "/dispatch/get-download-list")
        .then(
          response => {
            this.filesList = response.data;
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    showModal() {
      this.$refs.filesModal.show();
    },
    hideModal() {
      this.$refs.filesModal.hide();
    }
  }
};
</script>
